import Navbar from "../Component/Navbar";
import HeroSection from "../Component/Herosection";
import Footer from "../Component/Footer";
import React, { useEffect, useState } from "react";
import Feature from "../Component/Feature";
import Contact from "../Component/Contact";
import { useLocation } from "react-router-dom";

const Home = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("home");

  // Handle hash navigation from navbar clicks
  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (hash) {
      setActiveSection(hash);
      const element = document.getElementById(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  // Intersection Observer to update active section on scroll
  useEffect(() => {
    const sections = ['home', 'features', 'contact'];
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
            // Update URL hash without scrolling
            window.history.replaceState(null, '', `#${entry.target.id}`);
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      
      {/* Home Section */}
      <section id="home">
        <HeroSection />
      </section>
      
      {/* Features Section */}
      <section id="features">
        <Feature />
      </section>
      
      {/* Contact Section */}
      <section id="contact">
        <Contact />
      </section>
      
      <Footer />
    </>
  );
};

export default Home;